import React, { ReactElement, useEffect } from 'react'
import Divider from '../Divider'
import VotesOverview from './VotesOverview'

const VotesPanel = (): ReactElement => {
    useEffect(() => {
        window.location.hash = `#votes`
    }, [])

    return (
        <div className="panel">
            <Divider />
            <VotesOverview />
        </div>
    )
}

export default VotesPanel
